import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

function ChoiceEntry({ entryName, entryImg, entryImgAlt, children } ) {
  return (
    <div className="bottle my-5">
      <h4 className="has-text-danger is-uppercase">{entryName}</h4>
      <div className="columns m-0 is-vcentered">
        <div className="column is-2 my-2 has-text-centered">
          <GatsbyImage image={entryImg} alt={entryImgAlt} />
        </div>
        <div className="column">
          {children}
        </div>
      </div>
    </div>
  )
}

export default ChoiceEntry